import React from 'react';
import { useExperiments } from 'components/Experiment/useExperiments';
import { AEM_MISSION_ONBOARDING_HOMEPAGE_CONTENT } from 'constants/monetateExperiments';
import { Container, ContainerProps } from '@johnlewispartnership/wtr-content-component-library';

const OnboardingContent = (props: ContainerProps) => {
  const { getDecisionById } = useExperiments();

  const showOnboardingContent =
    getDecisionById(AEM_MISSION_ONBOARDING_HOMEPAGE_CONTENT.experiment).variant ===
    AEM_MISSION_ONBOARDING_HOMEPAGE_CONTENT.variant.showOnboarding;

  if (showOnboardingContent) {
    // We render the Container as normal as we only want to hide it in certain circumstances to avoid unnecessary image downloads etc
    return <Container {...props} />;
  }

  return null;
};

export default OnboardingContent;
